export enum SdohPermissionsEnum {
  ASSESSMENT_READ = 'Assessment.Read', // 'SDoHAssessment.Read' ???
  ASSESSMENT_WRITE = 'Assessment.Write',
  CANCEL_VISIT_READ = 'CancelVisit.Read',
  EXPIRED_SUBMISSION_UPDATE = 'ExpiredSubmission.Update',
  PENDING_REFERRAL_READ = 'PendingReferral.Read',
  PENDING_REFERRAL_WRITE = 'PendingReferral.Write',
  REFERRAL_ASSINGMENT_UPDATE = 'Referral.Assingment.Update',
  SUBMISSION_READ = 'Submission.Read',
  SUBMISSION_WRITE = 'Submission.Write',
  SUBMISSION_UPDATE = 'Submission.Update',
  SUBMISSION_NOTIFICATION_UPDATE = 'Submission.Notification.Update',
  COMMENTS_READ = 'SDoHReferral.Comment.Read',
  COMMENTS_CREATE = 'SDoHReferral.Comment.Create',
  COMMENTS_UPDATE = 'SDoHReferral.Comment.Update',
  ANALYTICS_READ = 'Analytics.Read'
}

export enum WCCPermissionsEnum {
  Assessment_Read = 'WCCAssessment.Read',
  Admission_Pending_Read = 'WCCAdmission.Pending.Read',
  Admission_Staffed_Read = 'WCCAdmission.Staffed.Read',
  Admission_All_Read = 'WCCAdmission.All.Read',
  Analytics_Read = 'Analytics.Read'
}

export enum SpecialtyProgramPermissionsEnum {
  CommunityResourcesUI = 'CommunityResources.UI'
}
